var _clipPath, _clipPath2, _clipPath3, _clipPath4, _clipPath5, _clipPath6, _clipPath7, _clipPath8, _clipPath9, _clipPath10, _clipPath11, _clipPath12, _clipPath13, _clipPath14, _clipPath15, _clipPath16, _clipPath17, _clipPath18, _clipPath19, _clipPath20, _clipPath21, _clipPath22, _clipPath23, _clipPath24, _clipPath25, _clipPath26, _clipPath27, _clipPath28, _clipPath29, _clipPath30, _clipPath31, _clipPath32, _clipPath33, _clipPath34, _clipPath35, _clipPath36, _clipPath37, _clipPath38, _clipPath39, _clipPath40, _clipPath41, _clipPath42, _clipPath43, _clipPath44, _clipPath45, _clipPath46, _clipPath47, _clipPath48, _clipPath49, _clipPath50, _clipPath51, _clipPath52, _clipPath53, _clipPath54, _clipPath55, _clipPath56, _clipPath57, _clipPath58, _clipPath59, _clipPath60, _clipPath61, _clipPath62, _clipPath63, _clipPath64, _clipPath65, _clipPath66, _clipPath67, _clipPath68, _clipPath69, _clipPath70, _clipPath71, _clipPath72, _clipPath73, _clipPath74, _clipPath75, _clipPath76, _clipPath77, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDlNt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 114,
    viewBox: "0 0 335 114",
    width: 335,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m335 0v114h-335v-114z"
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m159 0c6.075132 0 11 4.92486775 11 11v92c0 6.075132-4.924868 11-11 11h-148c-6.07513225 0-11-4.924868-11-11v-92c0-6.07513225 4.92486775-11 11-11z"
  }))), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m170 0v81c0 6.0751322-4.924868 11-11 11h-148c-6.07513225 0-11-4.9248678-11-11v-81z"
  }))), _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.596 0 5.25 6.776v-6.776h1.694v9.8h-1.442l-5.404-6.972v6.972h-1.694v-9.8z"
  }))), _clipPath5 || (_clipPath5 = /*#__PURE__*/React.createElement("clipPath", {
    id: "e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.43 0c1.106 0 1.932.294 2.45.826.546.532.798 1.316.798 2.282v4.382h-1.652v-.924c-.504.602-1.274 1.078-2.408 1.078-1.386 0-2.618-.798-2.618-2.282v-.028c0-1.596 1.246-2.38 3.052-2.38.826 0 1.414.126 1.988.308v-.182c0-1.05-.644-1.61-1.834-1.61-.826 0-1.442.182-2.114.462l-.448-1.33c.812-.364 1.61-.602 2.786-.602zm-.042 4.032c-1.092 0-1.736.462-1.736 1.232v.028c0 .714.63 1.12 1.442 1.12 1.12 0 1.974-.644 1.974-1.582v-.504c-.434-.168-1.008-.294-1.68-.294z"
  }))), _clipPath6 || (_clipPath6 = /*#__PURE__*/React.createElement("clipPath", {
    id: "f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m8.652 0c1.61 0 2.59 1.022 2.59 2.828v4.718h-1.694v-4.2c0-1.176-.546-1.806-1.498-1.806-.924 0-1.582.644-1.582 1.834v4.172h-1.694v-4.214c0-1.148-.56-1.792-1.498-1.792s-1.582.7-1.582 1.834v4.172h-1.694v-7.392h1.694v1.12c.476-.658 1.12-1.274 2.254-1.274 1.064 0 1.82.518 2.212 1.302.588-.784 1.372-1.302 2.492-1.302z"
  }))), _clipPath7 || (_clipPath7 = /*#__PURE__*/React.createElement("clipPath", {
    id: "g"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.612 0c2.352 0 3.542 1.848 3.542 3.976 0 .154-.014.308-.028.476h-5.432c.182 1.204 1.036 1.876 2.128 1.876.826 0 1.414-.308 2.002-.882l.994.882c-.7.84-1.666 1.386-3.024 1.386-2.142 0-3.794-1.554-3.794-3.836v-.028c0-2.114 1.498-3.85 3.612-3.85zm-.014 1.386c-1.036 0-1.764.798-1.918 1.946h3.794c-.112-1.092-.756-1.946-1.876-1.946z"
  }))), _clipPath8 || (_clipPath8 = /*#__PURE__*/React.createElement("clipPath", {
    id: "h"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.722 0v8.232h5.152v1.568h-6.874v-9.8z"
  }))), _clipPath9 || (_clipPath9 = /*#__PURE__*/React.createElement("clipPath", {
    id: "i"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.764 2.744v7.392h-1.694v-7.392zm.056-2.744v1.61h-1.82v-1.61z"
  }))), _clipPath10 || (_clipPath10 = /*#__PURE__*/React.createElement("clipPath", {
    id: "j"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.85 0c1.386 0 2.254.518 2.954 1.274l-1.064 1.134c-.518-.546-1.064-.924-1.904-.924-1.232 0-2.142 1.064-2.142 2.352v.028c0 1.316.91 2.366 2.212 2.366.798 0 1.386-.364 1.918-.91l1.022 1.008c-.728.812-1.582 1.386-3.024 1.386-2.198 0-3.822-1.722-3.822-3.822v-.028c0-2.1 1.624-3.864 3.85-3.864z"
  }))), _clipPath11 || (_clipPath11 = /*#__PURE__*/React.createElement("clipPath", {
    id: "k"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.612 0c2.352 0 3.542 1.848 3.542 3.976 0 .154-.014.308-.028.476h-5.432c.182 1.204 1.036 1.876 2.128 1.876.826 0 1.414-.308 2.002-.882l.994.882c-.7.84-1.666 1.386-3.024 1.386-2.142 0-3.794-1.554-3.794-3.836v-.028c0-2.114 1.498-3.85 3.612-3.85zm-.014 1.386c-1.036 0-1.764.798-1.918 1.946h3.794c-.112-1.092-.756-1.946-1.876-1.946z"
  }))), _clipPath12 || (_clipPath12 = /*#__PURE__*/React.createElement("clipPath", {
    id: "l"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m4.004 0c1.666 0 2.632 1.12 2.632 2.828v4.718h-1.694v-4.2c0-1.148-.574-1.806-1.582-1.806-.98 0-1.666.686-1.666 1.834v4.172h-1.694v-7.392h1.694v1.134c.476-.686 1.162-1.288 2.31-1.288z"
  }))), _clipPath13 || (_clipPath13 = /*#__PURE__*/React.createElement("clipPath", {
    id: "m"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.85 0c1.386 0 2.254.518 2.954 1.274l-1.064 1.134c-.518-.546-1.064-.924-1.904-.924-1.232 0-2.142 1.064-2.142 2.352v.028c0 1.316.91 2.366 2.212 2.366.798 0 1.386-.364 1.918-.91l1.022 1.008c-.728.812-1.582 1.386-3.024 1.386-2.198 0-3.822-1.722-3.822-3.822v-.028c0-2.1 1.624-3.864 3.85-3.864z"
  }))), _clipPath14 || (_clipPath14 = /*#__PURE__*/React.createElement("clipPath", {
    id: "n"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.612 0c2.352 0 3.542 1.848 3.542 3.976 0 .154-.014.308-.028.476h-5.432c.182 1.204 1.036 1.876 2.128 1.876.826 0 1.414-.308 2.002-.882l.994.882c-.7.84-1.666 1.386-3.024 1.386-2.142 0-3.794-1.554-3.794-3.836v-.028c0-2.114 1.498-3.85 3.612-3.85zm-.014 1.386c-1.036 0-1.764.798-1.918 1.946h3.794c-.112-1.092-.756-1.946-1.876-1.946z"
  }))), _clipPath15 || (_clipPath15 = /*#__PURE__*/React.createElement("clipPath", {
    id: "o"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m4.004 0c1.666 0 2.632 1.12 2.632 2.828v4.718h-1.694v-4.2c0-1.148-.574-1.806-1.582-1.806-.98 0-1.666.686-1.666 1.834v4.172h-1.694v-7.392h1.694v1.134c.476-.686 1.162-1.288 2.31-1.288z"
  }))), _clipPath16 || (_clipPath16 = /*#__PURE__*/React.createElement("clipPath", {
    id: "p"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.694 0v4.2c0 1.148.574 1.792 1.582 1.792.98 0 1.666-.672 1.666-1.82v-4.172h1.708v7.392h-1.708v-1.148c-.476.7-1.162 1.302-2.31 1.302-1.666 0-2.632-1.12-2.632-2.842v-4.704z"
  }))), _clipPath17 || (_clipPath17 = /*#__PURE__*/React.createElement("clipPath", {
    id: "q"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m8.652 0c1.61 0 2.59 1.022 2.59 2.828v4.718h-1.694v-4.2c0-1.176-.546-1.806-1.498-1.806-.924 0-1.582.644-1.582 1.834v4.172h-1.694v-4.214c0-1.148-.56-1.792-1.498-1.792s-1.582.7-1.582 1.834v4.172h-1.694v-7.392h1.694v1.12c.476-.658 1.12-1.274 2.254-1.274 1.064 0 1.82.518 2.212 1.302.588-.784 1.372-1.302 2.492-1.302z"
  }))), _clipPath18 || (_clipPath18 = /*#__PURE__*/React.createElement("clipPath", {
    id: "r"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.694 0v4.06c.546-.77 1.316-1.386 2.52-1.386 1.736 0 3.43 1.372 3.43 3.836v.028c0 2.45-1.68 3.836-3.43 3.836-1.232 0-2.002-.616-2.52-1.302v1.148h-1.694v-10.22zm2.114 4.144c-1.148 0-2.156.952-2.156 2.366v.028c0 1.414 1.008 2.366 2.156 2.366 1.162 0 2.114-.91 2.114-2.366v-.028c0-1.428-.966-2.366-2.114-2.366z"
  }))), _clipPath19 || (_clipPath19 = /*#__PURE__*/React.createElement("clipPath", {
    id: "s"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.612 0c2.352 0 3.542 1.848 3.542 3.976 0 .154-.014.308-.028.476h-5.432c.182 1.204 1.036 1.876 2.128 1.876.826 0 1.414-.308 2.002-.882l.994.882c-.7.84-1.666 1.386-3.024 1.386-2.142 0-3.794-1.554-3.794-3.836v-.028c0-2.114 1.498-3.85 3.612-3.85zm-.014 1.386c-1.036 0-1.764.798-1.918 1.946h3.794c-.112-1.092-.756-1.946-1.876-1.946z"
  }))), _clipPath20 || (_clipPath20 = /*#__PURE__*/React.createElement("clipPath", {
    id: "t"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m4.11013588.00075424.20186412.00216154v1.792h-.098c-1.484 0-2.52.966-2.52 2.926v2.814h-1.694v-7.392h1.694v1.666c.462-1.106 1.316-1.862 2.618-1.806z"
  }))), _clipPath21 || (_clipPath21 = /*#__PURE__*/React.createElement("clipPath", {
    id: "u"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.654 0c3.08 0 5.208 2.114 5.208 4.872v.028c0 2.758-2.128 4.9-5.208 4.9h-3.654v-9.8zm0 1.568h-1.932v6.664h1.932c2.058 0 3.402-1.386 3.402-3.304v-.028c0-1.918-1.344-3.332-3.402-3.332z"
  }))), _clipPath22 || (_clipPath22 = /*#__PURE__*/React.createElement("clipPath", {
    id: "v"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.43 0c1.106 0 1.932.294 2.45.826.546.532.798 1.316.798 2.282v4.382h-1.652v-.924c-.504.602-1.274 1.078-2.408 1.078-1.386 0-2.618-.798-2.618-2.282v-.028c0-1.596 1.246-2.38 3.052-2.38.826 0 1.414.126 1.988.308v-.182c0-1.05-.644-1.61-1.834-1.61-.826 0-1.442.182-2.114.462l-.448-1.33c.812-.364 1.61-.602 2.786-.602zm-.042 4.032c-1.092 0-1.736.462-1.736 1.232v.028c0 .714.63 1.12 1.442 1.12 1.12 0 1.974-.644 1.974-1.582v-.504c-.434-.168-1.008-.294-1.68-.294z"
  }))), _clipPath23 || (_clipPath23 = /*#__PURE__*/React.createElement("clipPath", {
    id: "w"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.632 0v2.03h1.988v1.456h-1.988v3.626c0 .658.336.924.91.924.378 0 .714-.084 1.05-.252v1.386c-.42.238-.882.378-1.526.378-1.246 0-2.128-.546-2.128-2.17v-3.892h-.938v-1.456h.938v-2.03z"
  }))), _clipPath24 || (_clipPath24 = /*#__PURE__*/React.createElement("clipPath", {
    id: "x"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.612 0c2.352 0 3.542 1.848 3.542 3.976 0 .154-.014.308-.028.476h-5.432c.182 1.204 1.036 1.876 2.128 1.876.826 0 1.414-.308 2.002-.882l.994.882c-.7.84-1.666 1.386-3.024 1.386-2.142 0-3.794-1.554-3.794-3.836v-.028c0-2.114 1.498-3.85 3.612-3.85zm-.014 1.386c-1.036 0-1.764.798-1.918 1.946h3.794c-.112-1.092-.756-1.946-1.876-1.946z"
  }))), _clipPath25 || (_clipPath25 = /*#__PURE__*/React.createElement("clipPath", {
    id: "y"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.948 0c2.268 0 3.934 1.722 3.934 3.836v.028c0 2.1-1.68 3.85-3.962 3.85-2.254 0-3.92-1.722-3.92-3.822v-.028c0-2.114 1.68-3.864 3.948-3.864zm-.028 1.484c-1.358 0-2.226 1.064-2.226 2.352v.028c0 1.288.938 2.366 2.254 2.366 1.372 0 2.24-1.064 2.24-2.338v-.028c0-1.302-.938-2.38-2.268-2.38z"
  }))), _clipPath26 || (_clipPath26 = /*#__PURE__*/React.createElement("clipPath", {
    id: "z"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.206 0c.588 0 .994.084 1.372.196v1.428c-.336-.112-.63-.182-.994-.182-.644 0-.98.35-.98 1.12v.406h1.96v1.4h-1.932v5.936h-1.694v-5.936h-.938v-1.414h.938v-.546c0-.812.21-1.428.602-1.82s.938-.588 1.666-.588z"
  }))), _clipPath27 || (_clipPath27 = /*#__PURE__*/React.createElement("clipPath", {
    id: "A"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.694 0v4.06c.546-.77 1.316-1.386 2.52-1.386 1.736 0 3.43 1.372 3.43 3.836v.028c0 2.45-1.68 3.836-3.43 3.836-1.232 0-2.002-.616-2.52-1.302v1.148h-1.694v-10.22zm2.114 4.144c-1.148 0-2.156.952-2.156 2.366v.028c0 1.414 1.008 2.366 2.156 2.366 1.162 0 2.114-.91 2.114-2.366v-.028c0-1.428-.966-2.366-2.114-2.366z"
  }))), _clipPath28 || (_clipPath28 = /*#__PURE__*/React.createElement("clipPath", {
    id: "B"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.764 2.744v7.392h-1.694v-7.392zm.056-2.744v1.61h-1.82v-1.61z"
  }))), _clipPath29 || (_clipPath29 = /*#__PURE__*/React.createElement("clipPath", {
    id: "C"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m4.11013588.00075424.20186412.00216154v1.792h-.098c-1.484 0-2.52.966-2.52 2.926v2.814h-1.694v-7.392h1.694v1.666c.462-1.106 1.316-1.862 2.618-1.806z"
  }))), _clipPath30 || (_clipPath30 = /*#__PURE__*/React.createElement("clipPath", {
    id: "D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.632 0v2.03h1.988v1.456h-1.988v3.626c0 .658.336.924.91.924.378 0 .714-.084 1.05-.252v1.386c-.42.238-.882.378-1.526.378-1.246 0-2.128-.546-2.128-2.17v-3.892h-.938v-1.456h.938v-2.03z"
  }))), _clipPath31 || (_clipPath31 = /*#__PURE__*/React.createElement("clipPath", {
    id: "E"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.694 0v3.962c.476-.686 1.162-1.288 2.31-1.288 1.666 0 2.632 1.12 2.632 2.828v4.718h-1.694v-4.2c0-1.148-.574-1.806-1.582-1.806-.98 0-1.666.686-1.666 1.834v4.172h-1.694v-10.22z"
  }))), _clipPath32 || (_clipPath32 = /*#__PURE__*/React.createElement("clipPath", {
    id: "F"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.672 0c2.196 0 3.648 1.92 3.648 4.32v.024c0 2.4-1.464 4.344-3.672 4.344s-3.648-1.92-3.648-4.32v-.024c0-2.4 1.464-4.344 3.672-4.344zm-.024 1.332c-1.296 0-2.124 1.32-2.124 2.988v.024c0 1.656.84 3.012 2.148 3.012s2.124-1.344 2.124-2.988v-.024c0-1.656-.852-3.012-2.148-3.012z"
  }))), _clipPath33 || (_clipPath33 = /*#__PURE__*/React.createElement("clipPath", {
    id: "G"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.288 0v8.46h-1.464v-6.96l-1.512.42-.312-1.2 2.268-.72z"
  }))), _clipPath34 || (_clipPath34 = /*#__PURE__*/React.createElement("clipPath", {
    id: "H"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m6.684 0-5.424 11.112h-1.26l5.424-11.112z"
  }))), _clipPath35 || (_clipPath35 = /*#__PURE__*/React.createElement("clipPath", {
    id: "I"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.672 0c2.196 0 3.648 1.92 3.648 4.32v.024c0 2.4-1.464 4.344-3.672 4.344s-3.648-1.92-3.648-4.32v-.024c0-2.4 1.464-4.344 3.672-4.344zm-.024 1.332c-1.296 0-2.124 1.32-2.124 2.988v.024c0 1.656.84 3.012 2.148 3.012s2.124-1.344 2.124-2.988v-.024c0-1.656-.852-3.012-2.148-3.012z"
  }))), _clipPath36 || (_clipPath36 = /*#__PURE__*/React.createElement("clipPath", {
    id: "J"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m6.684 0-5.424 11.112h-1.26l5.424-11.112z"
  }))), _clipPath37 || (_clipPath37 = /*#__PURE__*/React.createElement("clipPath", {
    id: "K"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.216 0c1.644 0 2.772 1.008 2.772 2.508v.024c0 1.32-.696 2.04-2.184 3.252l-1.728 1.44h3.996v1.296h-6.072v-1.164l2.892-2.46c1.152-.984 1.572-1.512 1.572-2.268 0-.828-.588-1.308-1.356-1.308s-1.296.42-1.932 1.26l-1.056-.828c.804-1.116 1.596-1.752 3.096-1.752z"
  }))), _clipPath38 || (_clipPath38 = /*#__PURE__*/React.createElement("clipPath", {
    id: "L"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.672 0c2.196 0 3.648 1.92 3.648 4.32v.024c0 2.4-1.464 4.344-3.672 4.344s-3.648-1.92-3.648-4.32v-.024c0-2.4 1.464-4.344 3.672-4.344zm-.024 1.332c-1.296 0-2.124 1.32-2.124 2.988v.024c0 1.656.84 3.012 2.148 3.012s2.124-1.344 2.124-2.988v-.024c0-1.656-.852-3.012-2.148-3.012z"
  }))), _clipPath39 || (_clipPath39 = /*#__PURE__*/React.createElement("clipPath", {
    id: "M"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.672 0c2.196 0 3.648 1.92 3.648 4.32v.024c0 2.4-1.464 4.344-3.672 4.344s-3.648-1.92-3.648-4.32v-.024c0-2.4 1.464-4.344 3.672-4.344zm-.024 1.332c-1.296 0-2.124 1.32-2.124 2.988v.024c0 1.656.84 3.012 2.148 3.012s2.124-1.344 2.124-2.988v-.024c0-1.656-.852-3.012-2.148-3.012z"
  }))), _clipPath40 || (_clipPath40 = /*#__PURE__*/React.createElement("clipPath", {
    id: "N"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m5.52 0v5.544c0 .996-.3 1.74-.792 2.232s-1.2.744-2.04.744c-1.296 0-2.136-.6-2.688-1.356l.972-1.008c.492.636.984.996 1.692.996.792 0 1.332-.528 1.332-1.656v-5.496z"
  }))), _clipPath41 || (_clipPath41 = /*#__PURE__*/React.createElement("clipPath", {
    id: "O"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.94 0c.948 0 1.656.252 2.1.708.468.456.684 1.128.684 1.956v3.756h-1.416v-.792c-.432.516-1.092.924-2.064.924-1.188 0-2.244-.684-2.244-1.956v-.024c0-1.368 1.068-2.04 2.616-2.04.708 0 1.212.108 1.704.264v-.156c0-.9-.552-1.38-1.572-1.38-.708 0-1.236.156-1.812.396l-.384-1.14c.696-.312 1.38-.516 2.388-.516zm-.036 3.456c-.936 0-1.488.396-1.488 1.056v.024c0 .612.54.96 1.236.96.96 0 1.692-.552 1.692-1.356v-.432c-.372-.144-.864-.252-1.44-.252z"
  }))), _clipPath42 || (_clipPath42 = /*#__PURE__*/React.createElement("clipPath", {
    id: "P"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.56 0 1.788 4.704 1.644-4.704h1.512l-2.52 6.516c-.504 1.296-1.068 1.776-2.088 1.776-.6 0-1.056-.144-1.5-.384l.492-1.08c.264.144.552.24.852.24.408 0 .66-.18.9-.72l-2.64-6.348z"
  }))), _clipPath43 || (_clipPath43 = /*#__PURE__*/React.createElement("clipPath", {
    id: "Q"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m4.332 0c1.548 0 2.484.54 3.288 1.308l-.948 1.092c-.672-.624-1.392-1.044-2.352-1.044-1.596 0-2.772 1.32-2.772 2.964v.024c0 1.644 1.164 2.976 2.772 2.976 1.032 0 1.692-.408 2.412-1.08l.948.96c-.876.912-1.836 1.488-3.408 1.488-2.448 0-4.272-1.908-4.272-4.32v-.024c0-2.388 1.788-4.344 4.332-4.344z"
  }))), _clipPath44 || (_clipPath44 = /*#__PURE__*/React.createElement("clipPath", {
    id: "R"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.512 2.352v6.336h-1.452v-6.336zm.048-2.352v1.38h-1.56v-1.38z"
  }))), _clipPath45 || (_clipPath45 = /*#__PURE__*/React.createElement("clipPath", {
    id: "S"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.256 0v1.74h1.704v1.248h-1.704v3.108c0 .564.288.792.78.792.324 0 .612-.072.9-.216v1.188c-.36.204-.756.324-1.308.324-1.068 0-1.824-.468-1.824-1.86v-3.336h-.804v-1.248h.804v-1.74z"
  }))), _clipPath46 || (_clipPath46 = /*#__PURE__*/React.createElement("clipPath", {
    id: "T"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m5.508 0v.996l-3.66 4.152h3.66v1.188h-5.508v-.996l3.66-4.152h-3.528v-1.188z"
  }))), _clipPath47 || (_clipPath47 = /*#__PURE__*/React.createElement("clipPath", {
    id: "U"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.096 0c2.016 0 3.036 1.584 3.036 3.408 0 .132-.012.264-.024.408h-4.656c.156 1.032.888 1.608 1.824 1.608.708 0 1.212-.264 1.716-.756l.852.756c-.6.72-1.428 1.188-2.592 1.188-1.836 0-3.252-1.332-3.252-3.288v-.024c0-1.812 1.284-3.3 3.096-3.3zm-.012 1.188c-.888 0-1.512.684-1.644 1.668h3.252c-.096-.936-.648-1.668-1.608-1.668z"
  }))), _clipPath48 || (_clipPath48 = /*#__PURE__*/React.createElement("clipPath", {
    id: "V"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.432 0c1.428 0 2.256.96 2.256 2.424v4.044h-1.452v-3.6c0-.984-.492-1.548-1.356-1.548-.84 0-1.428.588-1.428 1.572v3.576h-1.452v-6.336h1.452v.972c.408-.588.996-1.104 1.98-1.104z"
  }))), _clipPath49 || (_clipPath49 = /*#__PURE__*/React.createElement("clipPath", {
    id: "W"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.288 0v8.46h-1.464v-6.96l-1.512.42-.312-1.2 2.268-.72z"
  }))), _clipPath50 || (_clipPath50 = /*#__PURE__*/React.createElement("clipPath", {
    id: "X"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.216 0c1.644 0 2.772 1.008 2.772 2.508v.024c0 1.32-.696 2.04-2.184 3.252l-1.728 1.44h3.996v1.296h-6.072v-1.164l2.892-2.46c1.152-.984 1.572-1.512 1.572-2.268 0-.828-.588-1.308-1.356-1.308s-1.296.42-1.932 1.26l-1.056-.828c.804-1.116 1.596-1.752 3.096-1.752z"
  }))), _clipPath51 || (_clipPath51 = /*#__PURE__*/React.createElement("clipPath", {
    id: "Y"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m6.024 0v1.104l-2.34 2.4c1.272.156 2.472.804 2.472 2.352v.024c0 1.548-1.188 2.664-2.94 2.664-1.464 0-2.508-.612-3.216-1.476l1.032-.96c.6.708 1.272 1.104 2.208 1.104.828 0 1.452-.504 1.452-1.272v-.024c0-.828-.756-1.296-1.932-1.296h-.684l-.24-.924 2.268-2.412h-3.636v-1.284z"
  }))), _clipPath52 || (_clipPath52 = /*#__PURE__*/React.createElement("clipPath", {
    id: "Z"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m5.928 0v5.364h1.2v1.212h-1.2v1.884h-1.416v-1.884h-4.236l-.276-1.056 4.668-5.52zm-1.416 2.04-2.76 3.324h2.76z"
  }))), _clipPath53 || (_clipPath53 = /*#__PURE__*/React.createElement("clipPath", {
    id: "aa"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m5.832 0v1.308h-3.756l-.132 1.968c.396-.144.768-.24 1.332-.24 1.632 0 2.928.864 2.928 2.64v.024c0 1.716-1.26 2.844-3.12 2.844-1.284 0-2.292-.516-3.084-1.284l.912-1.068c.672.624 1.38 1.008 2.16 1.008 1.008 0 1.668-.576 1.668-1.452v-.024c0-.852-.72-1.392-1.74-1.392-.6 0-1.116.168-1.548.372l-.888-.588.24-4.116z"
  }))), _clipPath54 || (_clipPath54 = /*#__PURE__*/React.createElement("clipPath", {
    id: "ab"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.6 0c1.092 0 1.836.348 2.568.936l-.792 1.14c-.588-.456-1.08-.732-1.824-.732-1.464 0-1.992 1.524-2.016 2.676.492-.516 1.116-.852 2.016-.852 1.62 0 2.928.96 2.928 2.64v.024c0 1.668-1.356 2.856-3.12 2.856-1.032 0-1.776-.324-2.34-.888-.636-.636-1.02-1.512-1.02-3.204v-.024c0-2.568 1.224-4.572 3.6-4.572zm-.312 4.404c-1.044 0-1.704.672-1.704 1.476v.024c0 .852.696 1.5 1.74 1.5s1.68-.648 1.68-1.512v-.024c0-.84-.672-1.464-1.716-1.464z"
  }))), _clipPath55 || (_clipPath55 = /*#__PURE__*/React.createElement("clipPath", {
    id: "ac"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m5.904 0v1.116l-3.78 7.284h-1.668l3.768-7.104h-4.224v-1.296z"
  }))), _clipPath56 || (_clipPath56 = /*#__PURE__*/React.createElement("clipPath", {
    id: "ad"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.204 0c1.68 0 2.916.972 2.916 2.268v.024c0 .936-.516 1.5-1.224 1.872.924.42 1.512 1.02 1.512 2.016v.024c0 1.5-1.368 2.436-3.204 2.436s-3.204-.96-3.204-2.412v-.024c0-1.008.564-1.644 1.512-2.04-.708-.372-1.224-.936-1.224-1.872v-.024c0-1.284 1.236-2.268 2.916-2.268zm0 4.848c-.996 0-1.752.504-1.752 1.272v.024c0 .684.648 1.26 1.752 1.26s1.764-.564 1.764-1.26v-.024c0-.768-.768-1.272-1.764-1.272zm0-3.612c-.9 0-1.5.528-1.5 1.164v.024c0 .732.636 1.248 1.5 1.248s1.5-.516 1.5-1.236v-.024c0-.648-.6-1.176-1.5-1.176z"
  }))), _clipPath57 || (_clipPath57 = /*#__PURE__*/React.createElement("clipPath", {
    id: "ae"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.132 0c1.056 0 1.74.3 2.34.888.612.624 1.008 1.548 1.008 3.204v.024c0 2.7-1.332 4.572-3.6 4.572-1.164 0-1.98-.42-2.688-1.008l.804-1.128c.636.528 1.2.792 1.92.792 1.488 0 2.028-1.536 2.04-2.652-.468.564-1.116.9-1.98.9-1.788 0-2.976-1.044-2.976-2.664v-.024c0-1.644 1.272-2.904 3.132-2.904zm.012 1.272c-1.044 0-1.668.696-1.668 1.56v.024c0 .876.672 1.5 1.716 1.5 1.068 0 1.704-.696 1.704-1.512v-.024c0-.876-.684-1.548-1.752-1.548z"
  }))), _clipPath58 || (_clipPath58 = /*#__PURE__*/React.createElement("clipPath", {
    id: "af"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.672 0c2.196 0 3.648 1.92 3.648 4.32v.024c0 2.4-1.464 4.344-3.672 4.344s-3.648-1.92-3.648-4.32v-.024c0-2.4 1.464-4.344 3.672-4.344zm-.024 1.332c-1.296 0-2.124 1.32-2.124 2.988v.024c0 1.656.84 3.012 2.148 3.012s2.124-1.344 2.124-2.988v-.024c0-1.656-.852-3.012-2.148-3.012z"
  }))), _clipPath59 || (_clipPath59 = /*#__PURE__*/React.createElement("clipPath", {
    id: "ag"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m8 0 8 16h-16z"
  }))), _clipPath60 || (_clipPath60 = /*#__PURE__*/React.createElement("clipPath", {
    id: "ah"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m44 0v50h-44v-50z"
  }))), _clipPath61 || (_clipPath61 = /*#__PURE__*/React.createElement("clipPath", {
    id: "ai"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m16.5 0c4.6944204 0 8.5 3.80557963 8.5 8.5 0 3.5946495-2.2313616 6.6681365-5.3845373 7.9109136 7.0953009 1.6382724 12.3845373 7.9959957 12.3845373 15.5890864v1h-32v-1c0-7.8298198 5.62418161-14.3460416 13.0530599-15.7291804-2.9770301-1.3211511-5.0530599-4.303544-5.0530599-7.7708196 0-4.69442037 3.8055796-8.5 8.5-8.5z"
  }))), _clipPath62 || (_clipPath62 = /*#__PURE__*/React.createElement("clipPath", {
    id: "aj"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.368 0 4.5 5.808v-5.808h1.452v8.4h-1.236l-4.632-5.976v5.976h-1.452v-8.4z"
  }))), _clipPath63 || (_clipPath63 = /*#__PURE__*/React.createElement("clipPath", {
    id: "ak"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.384 0c1.944 0 3.372 1.476 3.372 3.288v.024c0 1.8-1.44 3.3-3.396 3.3-1.932 0-3.36-1.476-3.36-3.276v-.024c0-1.812 1.44-3.312 3.384-3.312zm-.024 1.272c-1.164 0-1.908.912-1.908 2.016v.024c0 1.104.804 2.028 1.932 2.028 1.176 0 1.92-.912 1.92-2.004v-.024c0-1.116-.804-2.04-1.944-2.04z"
  }))), _clipPath64 || (_clipPath64 = /*#__PURE__*/React.createElement("clipPath", {
    id: "al"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.50303521.00117296.19296479.00132628v1.536h-.084c-1.272 0-2.16.828-2.16 2.508v2.412h-1.452v-6.336h1.452v1.428c.396-.948 1.128-1.596 2.244-1.548z"
  }))), _clipPath65 || (_clipPath65 = /*#__PURE__*/React.createElement("clipPath", {
    id: "am"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.256 0v1.74h1.704v1.248h-1.704v3.108c0 .564.288.792.78.792.324 0 .612-.072.9-.216v1.188c-.36.204-.756.324-1.308.324-1.068 0-1.824-.468-1.824-1.86v-3.336h-.804v-1.248h.804v-1.74z"
  }))), _clipPath66 || (_clipPath66 = /*#__PURE__*/React.createElement("clipPath", {
    id: "an"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.452 0v3.396c.408-.588.996-1.104 1.98-1.104 1.428 0 2.256.96 2.256 2.424v4.044h-1.452v-3.6c0-.984-.492-1.548-1.356-1.548-.84 0-1.428.588-1.428 1.572v3.576h-1.452v-8.76z"
  }))), _clipPath67 || (_clipPath67 = /*#__PURE__*/React.createElement("clipPath", {
    id: "ao"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.096 0c2.016 0 3.036 1.584 3.036 3.408 0 .132-.012.264-.024.408h-4.656c.156 1.032.888 1.608 1.824 1.608.708 0 1.212-.264 1.716-.756l.852.756c-.6.72-1.428 1.188-2.592 1.188-1.836 0-3.252-1.332-3.252-3.288v-.024c0-1.812 1.284-3.3 3.096-3.3zm-.012 1.188c-.888 0-1.512.684-1.644 1.668h3.252c-.096-.936-.648-1.668-1.608-1.668z"
  }))), _clipPath68 || (_clipPath68 = /*#__PURE__*/React.createElement("clipPath", {
    id: "ap"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.50303521.00117296.19296479.00132628v1.536h-.084c-1.272 0-2.16.828-2.16 2.508v2.412h-1.452v-6.336h1.452v1.428c.396-.948 1.128-1.596 2.244-1.548z"
  }))), _clipPath69 || (_clipPath69 = /*#__PURE__*/React.createElement("clipPath", {
    id: "aq"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.432 0c1.428 0 2.256.96 2.256 2.424v4.044h-1.452v-3.6c0-.984-.492-1.548-1.356-1.548-.84 0-1.428.588-1.428 1.572v3.576h-1.452v-6.336h1.452v.972c.408-.588.996-1.104 1.98-1.104z"
  }))), _clipPath70 || (_clipPath70 = /*#__PURE__*/React.createElement("clipPath", {
    id: "ar"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m6.816 0v1.368h-2.664v7.032h-1.488v-7.032h-2.664v-1.368z"
  }))), _clipPath71 || (_clipPath71 = /*#__PURE__*/React.createElement("clipPath", {
    id: "as"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.096 0c2.016 0 3.036 1.584 3.036 3.408 0 .132-.012.264-.024.408h-4.656c.156 1.032.888 1.608 1.824 1.608.708 0 1.212-.264 1.716-.756l.852.756c-.6.72-1.428 1.188-2.592 1.188-1.836 0-3.252-1.332-3.252-3.288v-.024c0-1.812 1.284-3.3 3.096-3.3zm-.012 1.188c-.888 0-1.512.684-1.644 1.668h3.252c-.096-.936-.648-1.668-1.608-1.668z"
  }))), _clipPath72 || (_clipPath72 = /*#__PURE__*/React.createElement("clipPath", {
    id: "at"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.50303521.00117296.19296479.00132628v1.536h-.084c-1.272 0-2.16.828-2.16 2.508v2.412h-1.452v-6.336h1.452v1.428c.396-.948 1.128-1.596 2.244-1.548z"
  }))), _clipPath73 || (_clipPath73 = /*#__PURE__*/React.createElement("clipPath", {
    id: "au"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.50303521.00117296.19296479.00132628v1.536h-.084c-1.272 0-2.16.828-2.16 2.508v2.412h-1.452v-6.336h1.452v1.428c.396-.948 1.128-1.596 2.244-1.548z"
  }))), _clipPath74 || (_clipPath74 = /*#__PURE__*/React.createElement("clipPath", {
    id: "av"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.512 2.352v6.336h-1.452v-6.336zm.048-2.352v1.38h-1.56v-1.38z"
  }))), _clipPath75 || (_clipPath75 = /*#__PURE__*/React.createElement("clipPath", {
    id: "aw"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.256 0v1.74h1.704v1.248h-1.704v3.108c0 .564.288.792.78.792.324 0 .612-.072.9-.216v1.188c-.36.204-.756.324-1.308.324-1.068 0-1.824-.468-1.824-1.86v-3.336h-.804v-1.248h.804v-1.74z"
  }))), _clipPath76 || (_clipPath76 = /*#__PURE__*/React.createElement("clipPath", {
    id: "ax"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.384 0c1.944 0 3.372 1.476 3.372 3.288v.024c0 1.8-1.44 3.3-3.396 3.3-1.932 0-3.36-1.476-3.36-3.276v-.024c0-1.812 1.44-3.312 3.384-3.312zm-.024 1.272c-1.164 0-1.908.912-1.908 2.016v.024c0 1.104.804 2.028 1.932 2.028 1.176 0 1.92-.912 1.92-2.004v-.024c0-1.116-.804-2.04-1.944-2.04z"
  }))), _clipPath77 || (_clipPath77 = /*#__PURE__*/React.createElement("clipPath", {
    id: "ay"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.56 0 1.788 4.704 1.644-4.704h1.512l-2.52 6.516c-.504 1.296-1.068 1.776-2.088 1.776-.6 0-1.056-.144-1.5-.384l.492-1.08c.264.144.552.24.852.24.408 0 .66-.18.9-.72l-2.64-6.348z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(82)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h170v114h-170z",
    fill: "#1b3a7f"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)",
    transform: "translate(0 22)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h170v92h-170z",
    fill: "#afb0da"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(189.26 44.2)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h8.54v9.8h-8.54z",
    fill: "#242934"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e)",
    transform: "translate(10.374 2.31)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h6.678v7.644h-6.678z",
    fill: "#242934"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f)",
    transform: "translate(19.082 2.254)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h11.242v7.546h-11.242z",
    fill: "#242934"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#g)",
    transform: "translate(31.976 2.254)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h7.154v7.714h-7.154z",
    fill: "#242934"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#h)",
    transform: "translate(189.26 63.2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h6.874v9.8h-6.874z",
    fill: "#242934"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i)",
    transform: "translate(197.758 62.864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h1.82v10.136h-1.82z",
    fill: "#242934"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#j)",
    transform: "translate(201.328 65.454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h6.846v7.714h-6.846z",
    fill: "#242934"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#k)",
    transform: "translate(209.112 65.454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h7.154v7.714h-7.154z",
    fill: "#242934"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#l)",
    transform: "translate(217.974 65.454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h6.636v7.546h-6.636z",
    fill: "#242934"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#m)",
    transform: "translate(226.248 65.454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h6.846v7.714h-6.846z",
    fill: "#242934"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#n)",
    transform: "translate(234.032 65.454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h7.154v7.714h-7.154z",
    fill: "#242934"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#o)",
    transform: "translate(189.064 77.454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h6.636v7.546h-6.636z",
    fill: "#242934"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#p)",
    transform: "translate(197.66 77.608)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h6.65v7.546h-6.65z",
    fill: "#242934"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#q)",
    transform: "translate(206.424 77.454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h11.242v7.546h-11.242z",
    fill: "#242934"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#r)",
    transform: "translate(219.724 74.78)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h7.644v10.374h-7.644z",
    fill: "#242934"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#s)",
    transform: "translate(228.712 77.454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h7.154v7.714h-7.154z",
    fill: "#242934"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#t)",
    transform: "translate(237.574 77.465084)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h4.312v7.53491578h-4.312z",
    fill: "#242934"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#u)",
    transform: "translate(189.26 92.2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h8.862v9.8h-8.862z",
    fill: "#242934"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#v)",
    transform: "translate(199.522 94.51)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h6.678v7.644h-6.678z",
    fill: "#242934"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#w)",
    transform: "translate(207.572 92.578)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h4.62v9.548h-4.62z",
    fill: "#242934"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#x)",
    transform: "translate(213.298 94.454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h7.154v7.714h-7.154z",
    fill: "#242934"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#y)",
    transform: "translate(225.954 94.454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h7.882v7.714h-7.882z",
    fill: "#242934"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#z)",
    transform: "translate(234.998 91.696)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h4.578v10.304h-4.578z",
    fill: "#242934"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#A)",
    transform: "translate(189.064 103.78)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h7.644v10.22h-7.644z",
    fill: "#242934"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#B)",
    transform: "translate(198.486 103.864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h1.82v10.136h-1.82z",
    fill: "#242934"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#C)",
    transform: "translate(202.462 106.465084)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h4.312v7.53491578h-4.312z",
    fill: "#242934"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#D)",
    transform: "translate(207.656 104.578)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h4.62v9.422h-4.62z",
    fill: "#242934"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#E)",
    transform: "translate(213.998 103.78)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h6.636v10.22h-6.636z",
    fill: "#242934"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#F)",
    transform: "translate(69.684 100.456)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h7.32v8.688h-7.32z",
    fill: "#242934"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#G)",
    transform: "translate(77.94 100.54)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h3.288v8.46h-3.288z",
    fill: "#242934"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#H)",
    transform: "translate(82.08 99.424)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h6.684v11.112h-6.684z",
    fill: "#242934"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#I)",
    transform: "translate(88.896 100.456)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h7.32v8.688h-7.32z",
    fill: "#242934"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#G)",
    transform: "translate(97.152 100.54)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h3.288v8.46h-3.288z",
    fill: "#242934"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#J)",
    transform: "translate(101.292 99.424)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h6.684v11.112h-6.684z",
    fill: "#242934"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#K)",
    transform: "translate(108.192 100.48)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h6.072v8.52h-6.072z",
    fill: "#242934"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#L)",
    transform: "translate(115.644 100.456)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h7.32v8.688h-7.32z",
    fill: "#242934"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#M)",
    transform: "translate(124.332 100.456)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h7.32v8.688h-7.32z",
    fill: "#242934"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#L)",
    transform: "translate(133.02 100.456)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h7.32v8.688h-7.32z",
    fill: "#242934"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#N)",
    transform: "translate(59.252 46.6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h5.52v8.52h-5.52z",
    fill: "#242934"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#O)",
    transform: "translate(66.212 48.58)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h5.724v6.552h-5.724z",
    fill: "#242934"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#P)",
    transform: "translate(72.836 48.664)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h6.504v8.292h-6.504z",
    fill: "#242934"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Q)",
    transform: "translate(83.984 46.456)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h7.68v8.688h-7.68z",
    fill: "#242934"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#R)",
    transform: "translate(93.068 46.312)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h1.56v8.688h-1.56z",
    fill: "#242934"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#S)",
    transform: "translate(95.972 46.924)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h3.96v8.184h-3.96z",
    fill: "#242934"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#R)",
    transform: "translate(101.432 46.312)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h1.56v8.688h-1.56z",
    fill: "#242934"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#T)",
    transform: "translate(104.552 48.664)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h5.508v6.336h-5.508z",
    fill: "#242934"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#U)",
    transform: "translate(111.032 48.532)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h6.132v6.612h-6.132z",
    fill: "#242934"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#V)",
    transform: "translate(118.628 48.532)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h5.688v6.468h-5.688z",
    fill: "#242934"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#W)",
    transform: "translate(59.312 68.54)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h3.288v8.46h-3.288z",
    fill: "#242934"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#X)",
    transform: "translate(64.34 68.48)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h6.072v8.52h-6.072z",
    fill: "#242934"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Y)",
    transform: "translate(71.624 68.6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h6.156v8.544h-6.156z",
    fill: "#242934"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Z)",
    transform: "translate(78.956 68.54)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h7.128v8.46h-7.128z",
    fill: "#242934"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aa)",
    transform: "translate(87.272 68.6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h6.204v8.544h-6.204z",
    fill: "#242934"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ab)",
    transform: "translate(94.868 68.456)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h6.48v8.688h-6.48z",
    fill: "#242934"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ac)",
    transform: "translate(102.656 68.6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h5.904v8.4h-5.904z",
    fill: "#242934"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ad)",
    transform: "translate(109.604 68.48)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h6.408v8.64h-6.408z",
    fill: "#242934"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ae)",
    transform: "translate(117.236 68.456)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h6.48v8.688h-6.48z",
    fill: "#242934"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#af)",
    transform: "translate(125.084 68.456)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h7.32v8.688h-7.32z",
    fill: "#242934"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ag)",
    transform: "matrix(0 -1 1 0 164 59)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h16v16h-16z",
    fill: "#b81236"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ag)",
    transform: "matrix(0 -1 1 0 164 81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h16v16h-16z",
    fill: "#b81236"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ag)",
    transform: "matrix(0 -1 1 0 164 113)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h16v16h-16z",
    fill: "#b81236"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ah)",
    transform: "translate(11 45)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h44v50h-44z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ai)",
    transform: "translate(17 52)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h32v33h-32z",
    fill: "#8c909b"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aj)",
    transform: "translate(113.08 8.6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h7.32v8.4h-7.32z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ak)",
    transform: "translate(122.044 10.532)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h6.756v6.612h-6.756z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#al)",
    transform: "translate(130.276 10.541501)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h3.696v6.45849924h-3.696z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#am)",
    transform: "translate(134.728 8.924)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h3.96v8.184h-3.96z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#an)",
    transform: "translate(140.164 8.24)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h5.688v8.76h-5.688z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ao)",
    transform: "translate(147.256 10.532)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h6.132v6.612h-6.132z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ap)",
    transform: "translate(154.852 10.541501)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h3.696v6.45849924h-3.696z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aq)",
    transform: "translate(159.808 10.532)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h5.688v6.468h-5.688z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ar)",
    transform: "translate(170.416 8.6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h6.816v8.4h-6.816z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#as)",
    transform: "translate(176.908 10.532)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h6.132v6.612h-6.132z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#at)",
    transform: "translate(184.504 10.541501)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h3.696v6.45849924h-3.696z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#au)",
    transform: "translate(189.46 10.541501)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h3.696v6.45849924h-3.696z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#av)",
    transform: "translate(194.44 8.312)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h1.56v8.688h-1.56z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aw)",
    transform: "translate(197.344 8.924)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h3.96v8.184h-3.96z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ax)",
    transform: "translate(202.252 10.532)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h6.756v6.612h-6.756z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#au)",
    transform: "translate(210.484 10.541501)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h3.696v6.45849924h-3.696z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ay)",
    transform: "translate(214.84 10.664)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h6.504v8.292h-6.504z",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDlNt);
export default __webpack_public_path__ + "static/media/dl_nt.40949059a47fbc51d79f1261324e1c66.svg";
export { ForwardRef as ReactComponent };